import { useMutation } from '@apollo/client';
import { defineMessages, useIntl } from 'react-intl';

import { getGqlErrors } from '../../helpers';
import { SUBTASK_UPDATE } from '../graphql/mutations.graphql';
import toast from '../../../../../helpers/toast';

const useSubtaskUpdate = () => {
  const { formatMessage } = useIntl();

  const messages = defineMessages({
    updateSubtaskError: {
      id: 'Project.taskList.subTasks.update',
      defaultMessage: 'There was an error editing the question.',
      description: 'Error copy when updating a subtask label',
    },
  });

  const [updateSubtask] = useMutation(SUBTASK_UPDATE, {
    onCompleted: (data) => {
      const gqlErrors = getGqlErrors(data);
      if (gqlErrors.length) {
        toast.error(gqlErrors[0].message);
      }
    },
    onError: () => toast.error(formatMessage(messages.updateSubtaskError)),
  });

  return updateSubtask;
};

export default useSubtaskUpdate;
